<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title text-center">{{ title }}</h1>
      <rtvForm
        list-url="/complain"
        :id="id"
        checklist-type="complain"
        :form-type="formType"
        @add="onAdd"
        @edit="onEdit"
        :loading="loading"
      >
      </rtvForm>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import rtvForm from '../../components/RTVFormBox.vue';

export default {
  name: 'ComplainForm',
  components: {
    rtvForm
  },
  async mounted() {
    if (this.$route.name === 'rtv-new') {
      this.formType = 'new';
      this.id = null;
    } else {
      this.formType = 'update';
      this.id = this.$route.params.id;

      await this.getOne({
        id: this.id,
        router: this.$router
      });
    }
  },
  data() {
    return {
      formType: '',
      id: null
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'Add New' : 'Update One';
    },
    ...mapState('transactionComplain', ['loading', 'baseUrl', 'pagination', 'complainList', 'imageUrl']),
    ...mapState('auth', ['user']),
    ...mapState('cstSubmission', ['store'])
  },
  methods: {
    ...mapActions('rtv', ['getOne', 'postOne', 'patchOne', 'getImageUrl']),
    ...mapActions('cstSubmission', ['getStoreByUser']),
    onAdd({ rtv }) {
      this.postOne({
        rtv,
        router: this.$router,
        redirectUrl: '/rtv'
      });
    },
    onEdit({ rtv }) {
      this.patchOne({
        id: this.id,
        rtv,
        router: this.$router,
        redirectUrl: '/rtv'
      });
    }
  }
};
</script>
